import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './template.types';
import * as constants from './template.constants';

export const templateReducer = generateResourceReducer<types.ITemplate>({
  STORE: constants.STORE_TEMPLATE,
  CLEAR: constants.CLEAR_TEMPLATE,
});
